import { c as _c } from "react/compiler-runtime";
import { cn } from '@shape-construction/arch-ui/src/utils/classes';
import { ShapeLoader } from './ShapeLoader';
// The ambient treatment (opaque ground, aurora backdrop, cycling messages) is
// screen-only; the many inline call sites render just the small animated mark
// on a transparent background.
export const LoadingSpinner = t0 => {
  const $ = _c(10);
  const {
    variant
  } = t0;
  const t1 = variant === "screen";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("h-full w-full flex items-center justify-center", {
      "fixed inset-0 overflow-hidden bg-neutral-subtlest": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== variant) {
    t3 = variant === "screen" && <div className="shape-loader-backdrop" aria-hidden="true" />;
    $[2] = variant;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== variant) {
    t4 = <ShapeLoader variant={variant} />;
    $[4] = variant;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t2} data-testid="loading-spinner">{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};